var TextureSoftware = (function () {
    function TextureSoftware(width, height) {
        this._mipLevels = [];
        this._width = width;
        this._height = height;
    }
    Object.defineProperty(TextureSoftware.prototype, "textureType", {
        get: function () {
            return TextureSoftware.textureType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureSoftware.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureSoftware.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: true,
        configurable: true
    });
    TextureSoftware.prototype.dispose = function () {
        this._mipLevels = null;
    };
    TextureSoftware.prototype.isTexture = function (textureClass) {
        return this.textureType == textureClass.textureType;
    };
    TextureSoftware.prototype.uploadFromImage = function (image2D, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        this._mipLevels[miplevel] = image2D.getImageData().data;
    };
    TextureSoftware.prototype.uploadFromURL = function (urlRequest, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
    };
    TextureSoftware.prototype.getData = function (miplevel) {
        return this._mipLevels[miplevel];
    };
    TextureSoftware.prototype.getMipLevelsCount = function () {
        return this._mipLevels.length;
    };
    TextureSoftware.prototype.generateMipmaps = function () {
        //TODO
    };
    return TextureSoftware;
}());
export { TextureSoftware };
TextureSoftware.textureType = "texture2d";



// WEBPACK FOOTER //
// ../dist/lib/software/TextureSoftware.js